import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryLetterItem({letter, scrollToLetter}) {
    // Used in GlossaryLettersList to display one single letter

    // BUILD
    if (isNullOrUndefined(letter) || isNullOrUndefined(scrollToLetter))
        return null
    return (
        <div className={"cursor-pointer w-[24px] min-w-[24px] h-[32px] min-h-[32px] flex justify-center items-center border-[1px] border-greyLight9 hover:border-greyLight11 rounded-[6px] text-medium text-greyLight9 hover:text-greyLight11 text-[18px]"}
             onClick={scrollToLetter}>
            <span>
                {letter}
            </span>
        </div>
    );
}